import { Button, ButtonProps } from "@chakra-ui/react";
import React from "react";

interface APMainButtonProps {
  hideShadow?: boolean;
  isPrimary?: boolean;
}

const APMainButton = ({
  children,
  sx,
  hideShadow,
  isPrimary = true,
  ...others
}: ButtonProps & APMainButtonProps) => {
  return (
    <Button
      {...others}
      sx={{
        bg: isPrimary ? "primary" : "#fff",
        color: isPrimary ? "black" : "#fff",
        boxShadow: hideShadow ? "unset" : "0px 6px 0px #D0D23F",
        "&:hover": {
          bg: "#6bc1cb",
        },
        "&:focus": {
          boxShadow: hideShadow ? "unset" : "var(--chakra-shadows-outline)",
        },
        padding: "0px",
        minHeight: "45px",
        ...sx,
      }}
    >
      {children}
    </Button>
  );
};

export default APMainButton;
